import { getStore } from '../shared/redux/store';
import { ISystemState } from '../shared/redux/types';

export function getSystemState(): ISystemState {
  const store = getStore();

  return store.getState().system;
}
